import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom"; // To get query parameters
import loadingImage from "../assets/loading.png"; // Adjust the path if necessary
import { Link } from "react-router-dom"; // For navigation

const OrderSuccess = () => {
  const [searchParams] = useSearchParams();
  const [orderDetails, setOrderDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const sessionId = searchParams.get("session_id");

  useEffect(() => {
    if (sessionId) {
      // Fetch order details from backend
      fetch(`${process.env.REACT_APP_API_BASE_URL}/orders/stripe-session/${sessionId}`)

        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to fetch order details");
          }
          return response.json();
        })
        .then((data) => {
          setOrderDetails(data);
          setLoading(false);
        })
        .catch((err) => {
          setError(err.message);
          setLoading(false);
        });
    } else {
      setError("No session ID found");
      setLoading(false);
    }
  }, [sessionId]);

  if (loading) {
    return (
      <div className="h-screen lg: bg-[#191919]  bg-[#191919]  text-white flex flex-col justify-center items-center font-inter">
        <img src={loadingImage} alt="Loading" className="w-20 h-20 mb-4" />
        <h1 className="text-gray-400 text-lg">Loading your order details...</h1>
      </div>
    );
  }

  if (error) {
    return (
      <div className="h-screen lg: bg-[#191919]  bg-[#191919]  text-white flex flex-col justify-center items-center font-inter">
        <h1 className="text-red-500 text-xl">Error: {error}</h1>
      </div>
    );
  }

  return (
    <div className="h-screen lg: bg-[#191919]  bg-[#191919]  text-white flex flex-col justify-center items-center font-inter">
      {/* Back Button */}
      {/* <div className="absolute top-5 left-5">
        <button
          className="flex items-center text-white"
          onClick={() => window.history.back()}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 mr-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
          Back
        </button>
      </div> */}

      {/* Main Content */}
      <div className="text-center">
        {/* Loading Image */}
        <img src={loadingImage} alt="Loading" className="w-20 h-20 mx-auto" />

        {/* Order Status */}
        <h6 className="text-gray-400 mt-4">ORDER SUCCESSFUL</h6>
        <h1 className="text-primary text-2xl font-bold mt-2">
          Thank you for your order!
        </h1>

        <p className="text-gray-500 mt-1">
          You can track your order in the “My Order” section.
        </p>

        {/* Action Buttons */}
        <div className="flex justify-center space-x-4 mt-6">
          <Link
            to={"/track-order"}
            className="bg-primary text-black px-6 py-2 rounded-lg font-medium hover:bg-yellow-600"
          >
            Track my order
          </Link>
          {/* <button
            className="bg-primary text-black px-6 py-2 rounded-lg font-medium hover:bg-yellow-600"
            onClick={() =>
              navigator.clipboard.writeText(
                `Quantity: ${orderDetails.quantity}, Price: $${orderDetails.price}`
              )
            }
          >
            Copy Details
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default OrderSuccess;
